'use client';
import React from 'react';

import { useTranslations } from 'next-intl';
import styled from 'styled-components';
// import messages from './messages';

const errorMap = {
  firmwareNotSigned: {
    style: '',
  },
  outdatedFirmware: {
    style: '',
  },
  missingAppendix: {
    style: '',
  },
  firmwareOk: {
    style: 'background: #f5f5f5; color: black;',
  },
};

const Wrapper = styled.div<{ errorType: string[] | null }>`
  background: ${({ theme }) => theme.custom.colors.brand};
  color: white;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${({ errorType }) => {
    if (!errorType) {
      return;
    }

    return errorType.map(e => errorMap[e].style).join('');
  }}
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const Error = styled.div``;

{
  /* <IntlText
  index={messages[e]}
  values={{
    version: fwVersion,
  }}
  components={{
    link: <a href="https://www.prusa3d.com/drivers/">prusa3d.com/drivers</a>,
  }}
/>; */
}

/**
 * @todo translate
 * @todo udjust design - josef
 */
export default function DiagnosticInfo() {
  const [errors, setErrors] = React.useState<string[] | null>(null);
  const [fwVersion, setFwVersion] = React.useState<string | null>(null);
  const translations = useTranslations();

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const errors = queryParams.get('errors');
    const fwVersion = queryParams.get('fw');

    if (errors) {
      const parsedErrors = errors.split(',');
      setErrors(parsedErrors);
    }

    if (fwVersion) {
      setFwVersion(fwVersion);
    }
  }, [errors]);

  const messages = {
    firmwareNotSigned: translations(
      'app-components-DiagnosticErrors-firmwareNotSigned'
    ),
    outdatedFirmware: translations(
      'app-components-DiagnosticErrors-outdatedFirmware',
      {
        version: fwVersion,
        link: '/downloads', // @todo
      }
    ),
    missingAppendix: translations(
      'app-components-DiagnosticErrors-missingAppendix'
    ),
    firmwareOk: translations('app-components-DiagnosticErrors-firmwareOk'),
  };

  if (!errors && !fwVersion) {
    return null;
  }

  return (
    <Wrapper errorType={errors}>
      <Heading>
        {translations('app-components-DiagnosticErrors-diagnosticResults')}
      </Heading>
      {fwVersion && (
        <div>
          {translations('app-components-DiagnosticErrors-firmwareVersion')}:{' '}
          <strong>{fwVersion}</strong>
        </div>
      )}
      {errors &&
        errors.map(error => (
          <Error key={error}>
            {messages[error as keyof typeof messages] || error}
          </Error>
        ))}
    </Wrapper>
  );
}
